import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export function EarlyWarningBreadcrumb() {
  return (
    <div className="flex items-center gap-2 text-sm">
      <Link 
        to="/" 
        className="text-muted-foreground hover:text-foreground transition-colors"
      >
        Home
      </Link>
      <ChevronRight className="h-4 w-4 text-muted-foreground" />
      <span className="font-medium">Early Warning Register</span>
    </div>
  );
}